<template lang="html">
  <div>
    <div class="topbar">
      <div class="page-title-box">
        <h4 class="page-title">Buttons 按钮</h4>
        <p class="page-title-decs">按钮用于开始一个即时操作</p>
      </div>
    </div>
    <div class="card-box">
    <div style="margin-bottom:30px;">
      <Button>default</Button>
      <Button type='primary'>primary</Button>
      <Button type='success'>success</Button>
      <Button type='info'>info</Button>
      <Button type='danger'>danger</Button>
      <Button type='warning'>warning</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button plain>default</Button>
      <Button type='primary' plain>primary</Button>
      <Button type='success' plain>success</Button>
      <Button type='info' plain>info</Button>
      <Button type='danger' plain>danger</Button>
      <Button type='warning' plain>warning</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button round>default</Button>
      <Button type='primary' round>primary</Button>
      <Button type='success' round>success</Button>
      <Button type='info' round>info</Button>
      <Button type='danger' round>danger</Button>
      <Button type='warning' round>warning</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button plain round>default</Button>
      <Button type='primary' plain round>primary</Button>
      <Button type='success' plain round>success</Button>
      <Button type='info' plain round>info</Button>
      <Button type='danger' plain round>danger</Button>
      <Button type='warning' plain round>warning</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button round disabled>default</Button>
      <Button type='primary' round disabled>primary</Button>
      <Button type='success' round disabled>success</Button>
      <Button type='info'  round disabled>info</Button>
      <Button type='danger'  round disabled>danger</Button>
      <Button type='warning'  round disabled>warning</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button plain round disabled>default</Button>
      <Button type='primary' plain round disabled>primary</Button>
      <Button type='success' plain round disabled>success</Button>
      <Button type='info' plain round disabled>info</Button>
      <Button type='danger' plain round disabled>danger</Button>
      <Button type='warning' plain round disabled>warning</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button type='primary' size='sm'>small</Button>
      <Button type='warning'>normal</Button>
      <Button size='lg'>large</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button type='text'>Button</Button>
      <Button type='text' disabled>Button</Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button icon="re-icon-heart-on" circle></Button>
      <Button type="primary" icon="re-icon-x" circle></Button>
      <Button type="info" icon="re-icon-mic" circle></Button>
      <Button type="danger" icon="re-icon-music" circle></Button>
      <Button type="warning" icon="re-icon-thumbs-down" circle></Button>
      <Button type="success" icon="re-icon-thumbs-up" circle></Button>
    </div>
    <div style="margin-bottom:30px;">
      <Button icon="re-icon-home">default</Button>
      <Button type="primary" icon='re-icon-star-on'>primary</Button>
      <Button type='success' icon='re-icon-search'>success</Button>
      <Button type='info' icon="re-icon-user">info</Button>
      <Button type='danger' icon="re-icon-zap">danger</Button>
      <Button type='warning' icon="re-icon-triangle">warning</Button>
    </div>
    <div style="margin-bottom:30px;">
      <div style="width:200px; margin:0 auto">
        <Button block>default</Button>
        <Button type='primary' block>primary</Button>
        <Button type='success' block>success</Button>
        <Button type='info' block>info</Button>
        <Button type='danger' block>danger</Button>
        <Button type='warning' block>warning</Button>
      </div>
    </div>
    <div style="margin-bottom:30px;">
      <ButtonGroup>
        <Button>primary</Button>
        <Button>success</Button>
        <Button>info</Button>
      </ButtonGroup>
    </div>
  </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/view/button/index.vue